<script>
  import { format } from 'svelte-i18n';
  import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  export let row = {};
  export let props = {};

  let isOpen = false;
</script>

<ButtonDropdown bind:isOpen>
  <DropdownToggle color="none" tag="span">
    <Icon name="more-vertical" class={isOpen ? 'action-icon active' : 'action-icon'} />
  </DropdownToggle>
  <DropdownMenu>
    <DropdownItem on:click={() => props.onEdit(row)}>{$format('label.EDIT')}</DropdownItem>
    <DropdownItem divider />
    <DropdownItem on:click={() => props.onDelete(row)}>{$format('label.DELETE')}</DropdownItem>
  </DropdownMenu>
</ButtonDropdown>

<style lang="scss">
  i {
    border: 1px solid transparent;
    border-radius: var(--border-radius-base);
    color: var(--color-text);
    cursor: pointer;
    padding: var(--padding-small) var(--padding-xsmall);

    &.active,
    &:hover {
      background-color: var(--color-white);
      border-color: var(--color-gray-200);
    }
  }
</style>
